import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

import type { DashboardSkillsDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_SKILLS_DETAILS_LOADER } from "@application/loaders/dashboard_skills_details_loader";
import { DASHBOARD_SKILLS_LIST_LOADER } from "@application/loaders/dashboard_skills_list_loader";

import { DASHBOARD_SKILLS_LINK } from "@application/navigation/dashboard_skills_link";

import { Loader } from "@styled/loader";

const DashboardSkillsEdit = lazy(() =>
  import("./skills_edit").then((m) => ({ default: m.DashboardSkillsEdit })),
);

const DashboardSkillsNew = lazy(() =>
  import("./skills_new").then((m) => ({ default: m.DashboardSkillsNew })),
);

const DashboardSkillsDetails = lazy(() =>
  import("./skills_details").then((m) => ({
    default: m.DashboardSkillsDetails,
  })),
);
const DashboardSkillsList = lazy(() =>
  import("./skills_list").then((m) => ({ default: m.DashboardSkillsList })),
);

export const DASHBOARD_SKILLS_ROUTE = {
  path: "skills",
  handle: DASHBOARD_SKILLS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardSkillsList />
        </Suspense>
      ),
      loader: DASHBOARD_SKILLS_LIST_LOADER,
    },
    {
      path: ":id",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardSkillsDetails />
        </Suspense>
      ),
      loader: DASHBOARD_SKILLS_DETAILS_LOADER,
      handle: (data: DashboardSkillsDetailsQuery): Breadcrumb => ({
        name: data.skill.name,
        to: `/dashboard/skills/${data.skill.id}`,
      }),
    },
    {
      path: ":id/edit",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardSkillsEdit />
        </Suspense>
      ),
      loader: DASHBOARD_SKILLS_DETAILS_LOADER,
      handle: (data: DashboardSkillsDetailsQuery): Breadcrumb => ({
        name: data.skill.name,
        to: `/dashboard/skills/${data.skill.id}/edit`,
      }),
    },
    {
      path: "new",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardSkillsNew />
        </Suspense>
      ),
      handle: {
        name: "New",
        to: "/dashboard/skills/new",
      },
    },
  ],
} satisfies RouteObject;
